var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('p',[_vm._v("lo que buscas no está aquí..")])])
}
var staticRenderFns = []

export { render, staticRenderFns }